function t(e) {
  return Object.keys(e);
}
export {
  t as keysOf
};
